import React from 'react'
import styles from './S2DLayout.scss'
import {Modal} from 'common/styleguide/Modal'
import {styleguideVars as colors} from 'lib/styleguideVars'
import {ProgressBar} from 'common/ProgressBar'
import {StandardLayout} from 'common/layouts/StandardLayout'
import {CTA} from 'common/styleguide/CTA'

export class S2DLayout extends React.PureComponent {
  render () {
    const {
      title,
      subtitle,
      nextText,
      step,
      stepCount,
      children,
      disableNext,
      onClickNext,
      onClickPrev
    } = this.props
    return (
      <StandardLayout>
        <div className={styles.S2DLayout}>
          <Modal
            title={title}
            subtitle={subtitle}
            footer={<Footer step={step} stepCount={stepCount} disableNext={disableNext} onClickNext={onClickNext} onClickPrev={onClickPrev} nextText={nextText} />}
            className={styles.Modal}
            showCloseButton={false}>
            <div className={styles.modalContent}>
              {children}
            </div>
          </Modal>
        </div>
      </StandardLayout>
    )
  }
}

class Footer extends React.PureComponent {
  static defaultProps = {
    nextText: 'Next'
  }
  render () {
    const {step, stepCount, disableNext, onClickNext, onClickPrev, nextText} = this.props
    return (
      <div className={styles.Footer}>
        <div className={styles.steps}>
          <div className={styles.stepText}>
            <span>Step {step}</span>
            {stepCount && <span> of {stepCount}</span>}
          </div>
          <ProgressBar width='100px' height='4px' primaryColor={colors.purple} secondaryColor={colors.grey300} progress={stepCount ? step / stepCount : 0.25} />
        </div>
        <div className={styles.buttons}>
          {step > 1 && <a onClick={onClickPrev} className={styles.prev}>Previous</a>}
          {disableNext
            ? <CTA inline disabled margins={false} data-tip title={disableNext}>Next</CTA>
            : <CTA onClick={onClickNext} inline margins={false}>{nextText}</CTA>
          }
        </div>
      </div>
    )
  }
}
